<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container" v-on:click.stop="">
                    <h2 class="fs18 mb8">{{ params.title }}</h2>
                    <div class="modal-body radius8 pd24 mt8p mb8p">
                        <slot name="body">
                            <p class="fs14 mb16">{{ params.message }}</p>
                        </slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <button type="button" class="button fs16 w100p mt16 mb0 pd16 radius200" @click="closeModal()">{{ params.buttonMessage }}</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import modal from '@/assets/v2/modal'

export default {
  props: ['params'],
  methods: {
    closeModal () {
      modal.close()
      if (this.params.otherPageMoveObj) {
        this.moveToOtherPage()
      } else {
        this.appHomeBack()
      }
    },
    moveToOtherPage () {
      this.$router.push(this.params.otherPageMoveObj)
    }
  }
}
</script>
